<ion-app appLanguage>
  <ng-container *appLocaleInvalidate>
    <ion-router-outlet></ion-router-outlet>
  </ng-container>
</ion-app>
